<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formularioValido">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                            v-model="idEmpresaSelected"
                            :items="empresas"
                            item-text="razao_social"
                            item-value="id_empresa"
                            clearable
                            :label="$tc('company.self', 1)"
                            :rules="[(v) => !!v || $t('company.companyRequired')]"
                            @change="onEmpresaSelectChanged"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha
                            :items="unidadesItens"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                            v-model="idLinhaSelected"
                            :items="linhasSelect"
                            item-text="nome_linha"
                            item-value="id_linha"
                            clearable
                            multiple
                            :label="$tc('line.self', 1)"
                            :disabled="isLinhaSelectDisabled"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker
                            :label="$t('datetime.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker
                            :label="$t('datetime.finalDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="2" md="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="populaRelatorio"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable
            :key="tableKey"
            item-key="id_viagem_grid"
            cod-tabela="RELOPERACAO"
            :headers="tableHeaders"
            :items="itensLocalizados"
            :loading="loading"
            :default-multi-sort="defaultSort"
            :loading-text="$t('relOperacao.loading')"
            @update:headers="headers = $event"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('relOperacao.title')"
                    :token="token"
                    :items="itensLocalizados"
                    csv-title="reloperacao"
                    :csv-headers="exportHeadersResolved"
                    :pdf-title="$t('relOperacao.title')"
                    :pdf-headers="pdfExportHeaders"
                    pdf-filename="reloperacao"
                    hide-search
                ></CadastroToolbar>
            </template>
            <template v-slot:item.usability="{ item }">
                {{ item.usability != null ? `${item.usability}%` : '' }}
            </template>
        </MerusDataTable>
    </v-container>
</template>

<script>
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import MerusDataTable from '../components/Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import DateUtils from '../utils/dateutils.js';
import { isHeaderSelectedForExport } from '@/utils/relatorioExportProfiles';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        user: null,
        token: null,
        config: null,
        formularioValido: false,
        empresas: [],
        linhas: [],
        idEmpresaSelected: null,
        idLinhaSelected: [],
        unidades: [],
        unidadesSelecionadas: [],
        headers: [],
        itens: [],
        loading: false,
        dti: null,
        dtf: null,
        timeProps: { useSeconds: true },
        textFieldProps: { readonly: true },
        dtiProps: { max: null },
        dtfProps: { min: null },
    }),
    computed: {
        unidadesItens() {
            return this.unidades;
        },
        isLinhaSelectDisabled() {
            return !this.idEmpresaSelected;
        },
        linhasSelect() {
            if (!this.linhas.length || !this.idEmpresaSelected) {
                return [];
            }
            let filtradas = this.linhas.filter((l) => l.id_empresa === this.idEmpresaSelected);
            if (this.unidadesSelecionadas.length) {
                const set = new Set(this.unidadesSelecionadas.map((id) => Number(id)));
                filtradas = filtradas.filter((l) => {
                    const u = Array.isArray(l.unidades) ? l.unidades : [];
                    return u.some((id) => set.has(Number(id)));
                });
            }
            return filtradas;
        },
        tableKey() {
            return `rel-operacion-${this.$i18n.locale}`;
        },
        defaultHeaders() {
            const col = (key, value) => ({
                text: this.$t(`relOperacao.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
            });
            return [
                col('date', 'date'),
                col('month', 'month'),
                col('site', 'site'),
                col('client', 'client'),
                col('line', 'line'),
                col('vehicleType', 'vehicleType'),
                col('shift', 'shift'),
                col('direction', 'direction'),
                col('vehicleNumber', 'vehicleNumber'),
                col('driver', 'driver'),
                col('occupancy', 'occupancy'),
                col('capacity', 'capacity'),
                col('usability', 'usability'),
                col('availableSeats', 'availableSeats'),
                col('plannedArrivalTime', 'plannedArrivalTime'),
                col('actualArrivalTime', 'actualArrivalTime'),
                col('operationTime', 'operationTime'),
                col('operatorDelay', 'operatorDelay'),
                col('tripDelay', 'tripDelay'),
                col('kmTraveled', 'kmTraveled'),
                col('incidency', 'incidency'),
                col('manageableByOperator', 'manageableByOperator'),
                col('incidenceType', 'incidenceType'),
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        /** CSV/PDF: só colunas oficiais do relatório (ignora ids e extras do banco). */
        exportHeadersResolved() {
            const allowed = new Set(this.defaultHeaders.map((h) => h.value));
            const source = this.headers.length > 0 ? this.headers : this.defaultHeaders;
            return source.filter(
                (h) =>
                    h &&
                    h.value &&
                    h.value !== 'actions' &&
                    allowed.has(h.value) &&
                    isHeaderSelectedForExport(h)
            );
        },
        /**
         * PDF enxuto: remove mês, operador, tipo, lotação/utilização/assentos,
         * horário operação e flags de incidência (quase sempre vazios/redundantes).
         */
        pdfExportHeaders() {
            const pdfKeys = new Set([
                'date',
                'site',
                'line',
                'shift',
                'direction',
                'vehicleNumber',
                'driver',
                'occupancy',
                'plannedArrivalTime',
                'actualArrivalTime',
                'operatorDelay',
                'tripDelay',
                'kmTraveled',
                'incidenceType',
            ]);
            const byValue = new Map(this.exportHeadersResolved.map((h) => [h.value, h]));
            return [...pdfKeys]
                .map((key) => byValue.get(key) || this.defaultHeaders.find((h) => h.value === key))
                .filter(Boolean);
        },
        defaultSort() {
            return [
                { value: 'date', options: { text: this.$t('routs.increasing'), value: 1 } },
            ];
        },
        itensLocalizados() {
            return (this.itens || []).map((item) => this.localizeItem(item));
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
        unidadesSelecionadas() {
            this.idLinhaSelected = [];
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    methods: {
        initialize() {
            this.getConfig();
            this.populaEmpresas();
            this.populaLinhas();
            this.populaUnidades();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(
                        this.config.hora_inicial_dia_operacao
                    );
                }
            });
        },
        applySingleEmpresaIfOnlyOption() {
            if (this.idEmpresaSelected != null && this.idEmpresaSelected !== '') {
                return;
            }
            if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
                return;
            }
            this.idEmpresaSelected = this.empresas[0].id_empresa;
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data || [];
                    this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
                }
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                }
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [
                        { id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' },
                        ...(response.data || []),
                    ];
                }
            });
        },
        onEmpresaSelectChanged() {
            this.idLinhaSelected = [];
        },
        localizeItem(item) {
            return {
                ...item,
                month: this.formatMes(item.month),
                incidenceType: this.formatIncidence(item.incidenceType),
                incidency: this.formatIncidence(item.incidency),
                operatorDelay: this.formatNa(item.operatorDelay),
            };
        },
        formatMes(value) {
            if (value == null || String(value).trim() === '') {
                return value;
            }
            const match = String(value).trim().match(/^(\d{1,2})\/(\d{4})$/);
            if (!match) {
                return value;
            }
            const month = parseInt(match[1], 10);
            if (month < 1 || month > 12) {
                return value;
            }
            const date = new Date(0, month - 1, 1);
            const locale = this.$i18n.locale || 'pt-BR';
            const monthName = date.toLocaleDateString(locale, { month: 'long' });
            const capitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);
            return `${capitalized}`;
        },
        formatIncidence(value) {
            const normalized = String(value || '').trim().toLowerCase();
            if (
                value == null
                || normalized === ''
                || normalized === 'sin incidencia'
                || normalized === 'sem incidência'
                || normalized === 'sem incidencia'
            ) {
                return this.$t('relOperacao.noIncidence');
            }
            return value;
        },
        formatNa(value) {
            if (value == null || String(value).trim().toLowerCase() === 'n/a') {
                return this.$t('system.na');
            }
            return value;
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.formularioValido) {
                return;
            }
            this.loading = true;
            const body = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                id_empresa: this.idEmpresaSelected,
                id_linhas: this.idLinhaSelected.length
                    ? this.idLinhaSelected
                    : this.linhasSelect.map((l) => l.id_linha),
            };
            if (this.unidadesSelecionadas.length) {
                body.id_unidades = this.unidadesSelecionadas.map((id) => Number(id));
            }
            apiController.request(apiController.endpoints.getRelatoriooperacion, {
                data: body,
                onSuccess: (response) => {
                    this.itens = response.data || [];
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
    },
};
</script>
